import { render, staticRenderFns } from "./ErrorLogin.vue?vue&type=template&id=b30ad570&scoped=true&"
import script from "./ErrorLogin.vue?vue&type=script&lang=js&"
export * from "./ErrorLogin.vue?vue&type=script&lang=js&"
import style0 from "./ErrorLogin.vue?vue&type=style&index=0&id=b30ad570&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b30ad570",
  null
  
)

export default component.exports